/**
 * Bahasa Malaysia.
 *
 * The home market's own language, and the one this site shipped without — it
 * was MYR, Malaysian banks and Malaysian bet limits in English, 中文 and Tiếng
 * Việt. Comparable sites here carry Malay as a matter of course.
 *
 * House terms follow what Malaysian players already read: deposit and
 * pengeluaran rather than literal translations, rollover kept as the loanword
 * because that is what the market says, rebat for rebate, baki for balance.
 * Translating "rollover" to a purer Malay phrase would be more correct and less
 * understood.
 *
 * Formal-but-plain register — "anda" throughout, never the informal "kau". A
 * site handling somebody's money does not address them casually.
 */
export default {
  common: {
    loading: "Memuatkan…",
    cancel: "Batal",
    save: "Simpan",
    saving: "Menyimpan…",
    close: "Tutup",
    back: "Kembali",
    copy: "Salin",
    copied: "Disalin",
    all: "Semua",
    max: "Maks",
    optional: "pilihan",
    somethingWrong: "Ada masalah berlaku. Sila cuba lagi.",
    signIn: "Log masuk",
    register: "Daftar",
    signOut: "Log keluar",
  },

  nav: {
    lobby: "Permainan",
    money: "Kewangan",
    promotions: "Promosi",
    vip: "VIP",
    rebate: "Rebat",
    invite: "Jemput",
    winLoss: "Menang / kalah",
    account: "Akaun saya",
    language: "Bahasa",
  },

  menu: {
    soon: "Akan datang",
    notSignedIn: "Belum log masuk",
    menu: "Menu",
    closeMenu: "Tutup menu",

    play: "Main",
    money: "Kewangan",
    rewards: "Ganjaran",
    account: "Akaun",
    help: "Bantuan",

    games: "Permainan",
    bonuses: "Bonus",
    moneyPage: "Kewangan",
    rebate: "Kadar rebat",
    invite: "Jemput rakan",
    vip: "VIP",
    leaderboard: "Papan pendahulu",
    myAccount: "Akaun saya",
    winLoss: "Menang / kalah",
    howItWorks: "Cara ia berfungsi",
    contact: "Bantuan & hubungi",
  },

  footer: {
    help: "Bantuan",
    legal: "Perundangan",
    terms: "Terma & syarat",
    privacy: "Dasar privasi",
    deposits: "Cara membuat deposit",
    withdrawals: "Cara membuat pengeluaran",
    responsible: "18 tahun ke atas sahaja. Sila berjudi secara bertanggungjawab.",
  },

  authGate: {
    title: "Log masuk untuk teruskan",
    body: "Anda boleh melihat semuanya di sini. Tetapi untuk bermain, membuat deposit atau menuntut sebarang tawaran, anda perlukan akaun — kurang seminit sahaja.",
    createAccount: "Buka akaun",
  },

  prompt: {
    titleAction: "Log masuk untuk {action}",
    title: "Log masuk untuk teruskan",
    body: "Anda perlukan akaun dengan {site} untuk itu. Ia mengambil masa seminit, dan anda akan terus kembali ke sini.",
    createAccount: "Buka akaun",
    haveOne: "Saya sudah ada akaun",
    keepLooking: "Lihat-lihat dahulu",
    us: "kami",
    playGame: "main {game}",
  },

  auth: {
    signInToPlay: "Log masuk untuk bermain",
    username: "Nama pengguna",
    password: "Kata laluan",
    tabUsername: "Nama pengguna",
    tabEmail: "E-mel",
    tabPhone: "Telefon",
    emailPlaceholder: "you@example.com",
    phonePlaceholder: "Nombor telefon anda",
    sessionExpired: "Sesi anda telah tamat. Sila log masuk semula.",
    signingIn: "Sedang log masuk…",
    forgotPassword: "Lupa kata laluan?",
    createAccount: "Buka akaun",

    resetTitle: "Tetap semula kata laluan",
    resetSent: "Jika alamat itu berdaftar, kod telah dihantar.",
    resetSentHint: "Kod ini tamat dalam 10 minit dan hanya boleh digunakan sekali.",
    enterMyCode: "Masukkan kod saya",
    backToSignIn: "Kembali ke log masuk",
    email: "Alamat e-mel",
    sending: "Menghantar…",
    sendResetCode: "Hantar kod",

    newPasswordTitle: "Pilih kata laluan baharu",
    passwordUpdated: "Kata laluan dikemas kini. Membawa anda ke log masuk…",
    resetCode: "Kod tetap semula",
    resetCodeHint: "Kod 6 digit yang kami e-melkan kepada anda. Ia tamat 10 minit selepas dihantar.",
    newPassword: "Kata laluan baharu",
    passwordRule: "Sekurang-kurangnya 10 aksara.",
    confirmPassword: "Sahkan kata laluan",
    updating: "Mengemas kini…",
    updatePassword: "Kemas kini kata laluan",
    requestNewCode: "Minta kod baharu",
  },

  account: {
    title: "Akaun saya",
    sectionAccount: "Akaun",
    sectionSecurity: "Keselamatan",
    sectionPreferences: "Tetapan",

    verification: "Pengesahan",
    verified: "Disahkan",
    accountsOnFile: "{count} akaun bank disimpan.",
    accountsOnFilePlural: "{count} akaun bank disimpan.",
    beingChecked: "Sedang disemak",
    beingCheckedDetail: "Biasanya siap dalam beberapa jam.",
    notAccepted: "Tidak diterima",
    notAcceptedDetail: "Semak maklumat anda dan cuba lagi.",
    notFinished: "Belum selesai",
    notFinishedDetail: "Maklumat anda telah disimpan tetapi belum dihantar kepada kami.",
    notStarted: "Belum bermula",
    notStartedDetail: "Diperlukan sebelum pengeluaran pertama anda, supaya kami tahu ke mana hendak membayar.",
    manageBanks: "Urus akaun bank",
    addBank: "Tambah akaun bank anda",

    password: "Kata laluan",
    passwordIntro: "Kami tetap meminta kata laluan semasa walaupun anda sudah log masuk — sesi log masuk bukan bukti siapa yang sedang memegang telefon itu.",
    currentPassword: "Kata laluan semasa",
    newPassword: "Kata laluan baharu",
    newPasswordHint: "Sekurang-kurangnya 10 aksara. Satu frasa pendek yang anda ingat lebih baik daripada aksara rawak yang pendek.",
    confirmNewPassword: "Sahkan kata laluan baharu",
    changePassword: "Tukar kata laluan",

    currency: "Mata wang",
    currencyIntro: "Hanya boleh ditukar semasa baki anda kosong dan sebelum transaksi pertama. Selepas itu ia akan mengubah maksud penyata lama anda, jadi sembang langsung perlu menguruskannya.",
    chooseCurrency: "Pilih mata wang",
    changeCurrency: "Tukar mata wang",
  },

  verifyEmail: {
    title: "Sahkan alamat e-mel anda",
    sentTo: "Kami menghantar kod 6 digit ke",
    enterIt: "Masukkan kod itu untuk melengkapkan akaun anda.",
    checking: "Menyemak…",
    verify: "Sahkan",
    resending: "Menghantar…",
    resend: "Hantar semula kod",
    useDifferent: "Guna akaun lain",
    expires: "Kod ini tamat dalam 10 minit.",
  },

  register: {
    title: "Buka akaun anda",
    email: "Alamat e-mel",
    emailHint: "Kami akan menghantar kod 6 digit untuk mengesahkannya.",
    signInInstead: "Log masuk sahaja",
    sending: "Menghantar…",
    sendCode: "Hantar kod",

    enterCodeSentTo: "Masukkan kod yang kami hantar ke",
    verificationCode: "Kod pengesahan",
    checking: "Menyemak…",
    continue: "Teruskan",
    useDifferentEmail: "Guna e-mel lain",
    resend: "Hantar semula",

    username: "Nama pengguna",
    usernameHint: "Huruf, nombor dan garis bawah.",
    password: "Kata laluan",
    passwordHint: "Sekurang-kurangnya 10 aksara.",
    confirmPassword: "Sahkan kata laluan",
    fullName: "Nama penuh",
    fullNameHint: "Mesti sama dengan nama akaun bank anda — digunakan untuk deposit dan pengeluaran.",
    nickname: "Nama panggilan",
    nicknameHint: "Nama yang dilihat oleh pemain lain.",
    phoneCode: "Kod",
    phone: "Telefon",
    creating: "Membuka…",
    createAccount: "Buka akaun",
    alreadyHave: "Sudah ada akaun?",

    needsMore: "Perlu {count} aksara lagi.",
    needsMorePlural: "Perlu {count} aksara lagi.",
    passwordsDoNotMatch: "Kata laluan tidak sepadan.",
    nicknameRequired: "Pilih nama panggilan — sekurang-kurangnya 3 huruf atau nombor.",
    phoneRequired: "Masukkan nombor telefon anda.",
    fullNameRequired: "Masukkan nama penuh anda seperti pada akaun bank anda.",
  },

  bank: {
    title: "Akaun bank anda",
    intro: "Pengeluaran hanya dimasukkan ke akaun yang anda telah simpan dan kami telah semak — tidak pernah ke akaun yang ditaip semasa pengeluaran. Itulah yang memastikan wang anda hanya boleh dicapai oleh anda.",
    confirmed: "Disahkan",
    weCanPayAny: "Kami boleh bayar ke mana-mana akaun ini",
    wePayInto: "Kami bayar ke",
    pickAtWithdrawal: "Anda pilih yang mana semasa membuat pengeluaran. Kesemuanya mesti atas nama anda sendiri — itulah yang kami semak sebelum menambahnya.",
    checkingNew: "Kami sedang menyemak akaun baharu anda.",
    carryOnMeantime: "Sementara itu, pengeluaran berjalan seperti biasa ke akaun di atas.",
    spottedMistake: "Ternampak kesilapan? Hubungi sembang langsung — permohonan tidak boleh diubah setelah sampai kepada pasukan kami.",
    couldNotApprove: "Kami tidak dapat meluluskan perubahan terakhir anda.",
    maxAccounts: "Anda telah menyimpan had maksimum {count} akaun. Hubungi sembang langsung jika perlu membuang satu.",
    tryAgain: "Cuba lagi",
    addAnother: "Tambah akaun bank lain",

    bankLabel: "Bank",
    selectYourBank: "Pilih bank anda",
    otherTypeBelow: "Lain-lain — taip di bawah",
    bankNamePlaceholder: "Nama bank",
    holderName: "Nama pemegang akaun",
    accountNumber: "Nombor akaun",
    whyAdding: "Kenapa anda menambah akaun ini?",
    stillHasToBe: "Masih perlu atas nama {name} — bank lain boleh, orang lain tidak.",
    sending: "Menghantar…",
    sendForChecking: "Hantar untuk semakan",

    weAreChecking: "Kami sedang menyemak",
    sentAt: "Dihantar {when}. Biasanya siap dalam beberapa jam.",
    couldNotConfirm: "Kami tidak dapat mengesahkan akaun ini",
    checkAndRetry: "Semak maklumat bank anda dan cuba lagi.",

    addYours: "Tambah akaun bank anda",
    neededBefore: "Diperlukan sebelum pengeluaran pertama anda, supaya kami tahu ke mana hendak menghantar wang anda. Maklumat bank sahaja — tiada dokumen diperlukan.",
    starting: "Memulakan…",
    start: "Mula",

    yourDetails: "Maklumat bank anda",
    mustComeFrom: "Wang mesti datang dari akaun ini, dan kami hanya bayar balik ke akaun yang sama.",
    hasToMatch: "Mesti sepadan dengan nama pada akaun anda:",
    weWillSave: "Kami akan menyimpan nama ini dan menyemak setiap pembayaran masuk dan keluar terhadapnya.",
    doesNotMatch: "Ini tidak sepadan dengan nama pada akaun anda. Hubungi sembang langsung jika nama anda telah bertukar.",
    matches: "✓ Sepadan dengan nama pada akaun anda.",
    finishLaterTitle: "Simpan maklumat ini tanpa menghantarnya lagi",
    finishLater: "Sambung nanti",
  },

  misc: {
    siteUnavailable_title: "Laman tidak tersedia",
    verifyYourEmail: "Sahkan e-mel anda",
    reasonGiven: "Sebab diberikan",
    createAccount: "Buka akaun",
    seeBonuses: "Lihat bonus",
    siteUnavailable: "Laman ini tidak tersedia buat masa ini. Sila semak alamatnya dan cuba lagi.",
    notifications: "Pemberitahuan",
    needAttention: "{count} perkara memerlukan perhatian anda",
    allCaughtUp: "Tiada apa-apa yang baharu.",
    qrAlt: "Alamat deposit sebagai kod QR",
    qrTooLong: "Alamat ini terlalu panjang untuk dipaparkan sebagai kod — sila salin sahaja.",
    youSubmitted: "Anda telah hantar",
    enterCodeWeSent: "Masukkan kod 6 digit yang kami hantar kepada anda.",
    sentAgain: "Dihantar semula",
    resend: "Hantar semula",
  },

  support: {
    help: "Bantuan",
    tabChat: "Sembang",
    tabFaq: "Soalan lazim",
    tabContact: "Hubungi",
    automatedNotice: "Jawapan automatik. Untuk apa-apa berkaitan akaun atau wang anda sendiri, gunakan WhatsApp di bawah Hubungi — di sana ada orang yang benar-benar boleh menyemak.",
    openWhatsApp: "Buka WhatsApp →",
    whatsappIntro: "WhatsApp ialah cara terpantas untuk menghubungi kami, dan satu-satunya saluran di mana kami boleh melihat akaun anda.",
    demoNumber: "Nombor demo — tiada sesiapa di hujung sana. Tetapkan nombor sebenar dalam tetapan jenama laman ini sebelum pelancaran.",
  },

  legal: {
    notRealTitle: "Ini bukan dokumen sebenar.",
    notRealBody: "Ini hanyalah rangka bahagian yang diperlukan oleh {brand}, bukan teks perundangan yang telah disemak, dan ia tidak mengikat sesiapa. Ia mesti diganti dengan terma yang digubal khusus untuk pengendali ini, lesennya dan pasaran yang diterimanya sebelum laman ini beroperasi.",
    englishOnly: "Draf ini diterbitkan dalam bahasa Inggeris sahaja. Ia akan diterjemah setelah teks akhir dimuktamadkan — terjemahan mesin bagi sesuatu perjanjian bukanlah perjanjian.",
    version: "Versi: draf belum diterbitkan. Tiada tarikh berkuat kuasa.",
    notFound: "Dokumen tidak dijumpai.",
  },

  live: {
    title: "Taruhan langsung",
    playing: "{count} sedang bermain",
    quiet: "Tiada sesiapa sedang bermain sekarang.",
    quietBody: "Taruhan akan dipaparkan di sini sebaik sahaja diselesaikan.",
    stat_paid: "Dibayar hari ini",
    stat_biggest: "Kemenangan terbesar hari ini",
    stat_rounds: "Pusingan hari ini",
    topToday: "Kemenangan terbesar hari ini",
    noWins: "Belum ada kemenangan hari ini.",
    won: "menang",
    staked: "dipertaruhkan",
  },

  providers: {
    title: "Studio permainan kami",
    subtitle: "Permainan dibekalkan oleh studio berlesen.",
  },

  trust: {
    licensed: "Pengendali berlesen",
    licensedBody: "Beroperasi di bawah lesen yang dinyatakan dalam terma kami.",
    payouts: "Bayaran hari yang sama",
    payoutsBody: "Disemak oleh manusia, biasanya dalam beberapa minit.",
    support: "Sokongan sepanjang masa",
    supportBody: "Sembang langsung, setiap hari.",
    fair: "Setiap pusingan direkodkan",
    fairBody: "Setiap pusingan direkod dan boleh diaudit.",
  },

  help: {
    title: "Cara ia berfungsi",
    intro: "Panduan ringkas tentang perkara yang paling kerap ditanya.",
    openIt: "Pergi ke sana",
    stepsLabel: "{count} langkah",

    deposit_title: "Menambah wang",
    deposit_body: "Buka Kewangan, pilih mata wang yang anda bayar, kemudian caranya. Anda akan melihat akaun atau alamat dompet untuk dibayar, dan rujukan untuk dicatat. Tekan \"Saya sudah bayar\" setelah menghantarnya — itu memasukkan deposit ke dalam barisan semakan kami, ia tidak mengkreditkan apa-apa dengan sendirinya. Seorang pekerja menyemak setiap pembayaran, biasanya dalam beberapa minit. Baki anda berubah sebaik sahaja ia disahkan.",
    deposit_note: "Wang mesti datang daripada akaun atas nama anda sendiri. Pembayaran daripada orang lain tidak boleh dikreditkan.",

    withdraw_title: "Mengeluarkan wang",
    withdraw_body: "Simpan akaun bank dahulu — kami hanya membayar ke akaun yang anda telah simpan dan kami telah semak, tidak pernah ke akaun yang ditaip pada masa itu. Buka Kewangan, pilih Pengeluaran, masukkan jumlah dan sahkan. Jumlah itu ditahan sebaik sahaja anda memohon, jadi ia terus keluar daripada baki yang boleh anda mainkan.",
    withdraw_note: "Nama pada akaun bank mesti sama tepat dengan nama pada akaun anda. Anda boleh membatalkan permohonan daripada Rekod semasa ia masih menunggu, dan wang itu akan kembali.",

    bonus_title: "Bonus dan tunai",
    bonus_body: "Kredit bonus belum menjadi milik anda untuk dikeluarkan sehingga anda melengkapkan rollover. Setiap bonus membawa syarat rolloverya sendiri, ditetapkan semasa ia diberikan, dan taruhan anda melangsaikan yang paling lama dahulu. Apabila sesuatu bonus selesai rollover, ia menjadi tunai dan boleh dikeluarkan seperti wang lain.",
    bonus_note: "Tab Pindahan menunjukkan berapa banyak rollover yang tinggal dan berapa yang sudah sedia untuk dipindahkan.",

    rebate_title: "Rebat",
    rebate_body: "Anda memperoleh sebahagian daripada setiap taruhan anda, menang atau kalah — bukan sebahagian daripada kekalahan anda. Ia dijumlahkan sekali sehari dan dikreditkan ke baki bonus anda. Kadarnya bergantung kepada pembekal permainan, dan tahap VIP anda menambahnya lagi.",
    rebate_note: "Kadar semasa bagi setiap pembekal ada pada halaman Rebat.",

    stillStuck: "Masih tidak jelas?",
    stillStuckBody: "Sembang langsung dibuka sepanjang masa, dan boleh melihat akaun anda.",
    contactUs: "Hubungi kami",
  },

  lobby: {
    categories: {
      slots: "Slot",
      live: "Kasino Langsung",
      sports: "Sukan",
      fishing: "Menembak Ikan",
      lottery: "Loteri 4D",
      cockfight: "Sabung Ayam",
      horse: "Lumba Kuda",
      esports: "E-sukan",
    },

    banners: {
      welcomeTitle: "Bonus selamat datang",
      welcomeBody: "Sehingga 150% tambahan untuk deposit pertama anda",
      cashbackTitle: "Pulangan tunai harian",
      cashbackBody: "Sedikit pulangan untuk setiap pusingan yang anda main",
      friendTitle: "Bawa rakan",
      friendBody: "Kedua-dua anda mendapat ganjaran",
    },

    trust: {
      withdraw: "Pengeluaran",
      withdrawValue: "Hari yang sama",
      chat: "Sembang langsung",
      chatValue: "Sentiasa dibuka",
      payBy: "Bayar dengan",
      payByValue: "Bank atau USDT",
    },

    popular: "Popular",
    notConnected: "Permainan ini belum disambungkan.",
    notConnectedTry: "Permainan ini belum disambungkan. Sila cuba yang lain.",
    showSlide: "Papar slaid {number}",
    dismiss: "Tutup",
    winningNow: "Sedang menang",
    pickAGame: "Pilih permainan",
    comingSoon: "Akan datang",
    showAll: "Lihat semua",
    gamesOnTheWay: "Permainan akan menyusul",
    hot: "HOT",
    gameStudios: "Studio permainan",
    bonuses: "Bonus",
    viewAll: "Lihat semua",
    bonus: "Bonus",
  },

  vip: {
    title: "VIP",
    intro: "Tahap anda ditentukan oleh jumlah keseluruhan deposit anda sepanjang masa. Ia tidak pernah turun.",
    currentTier: "Tahap semasa",
    depositedToDate: "Jumlah deposit setakat ini",
    toReach: "Untuk mencapai {tier}",
    topTier: "Anda berada di tahap tertinggi.",
    allTiers: "Semua tahap",
    tier: "Tahap",
    deposited: "Deposit",
    extraRebate: "Rebat tambahan",
    includes: "Termasuk",
    you: "Anda",
    orMore: "{amount} atau lebih",
    notPaidTitle: "Bonus rebat mengikut tahap belum dibayar lagi.",
    notPaidBody: "Tahap dan deposit anda direkodkan mulai sekarang, dan rebat biasa dibayar seperti yang diterbitkan. Kami akan memaklumkan di sini apabila bonus tahap mula berkuat kuasa.",
  },

  promotions: {
    title: "Promosi",
    intro: "Semua yang sedang berjalan di laman ini, berserta terma penuh.",
    hideTerms: "Sembunyikan terma",
    readTerms: "Baca terma",
    draftTitle: "Terma ini masih draf.",
    draftBody: "Angka, tarikh dan nama pembekal di atas hanyalah sementara dan akan disahkan sebelum sebarang tawaran diiklankan. Peraturannya sendiri — bayaran minimum, jalur kadar VIP dan kategori yang dikecualikan — sudah berkuat kuasa dan dibayar seperti yang dinyatakan.",
  },

  rebate: {
    title: "Kadar rebat",
    intro: "Diperoleh pada setiap pusingan yang anda main, menang atau kalah.",
    settingUp: "Kadar rebat sedang disediakan. Ia akan dipaparkan di sini sebentar lagi.",
    toYou: "untuk anda",
    referral: "Rujukan",
    shareholder: "Pemegang saham",
    supplier: "Pembekal",
    you: "Anda",
    howItAddsUp: "Bagaimana ia dikira",
    exampleFull: "Rebat dikira daripada jumlah taruhan anda, bukan daripada kekalahan anda. Bertaruh {stake} pada slot dengan kadar {rate} memberi anda {reward} kembali — sama ada pusingan itu menang atau kalah.",
    example: "Rebat dikira daripada jumlah taruhan anda, bukan daripada kekalahan anda.",
    exampleDaily: "Ia dijumlahkan setiap hari dan dikreditkan ke baki bonus anda.",
  },

  invite: {
    title: "Jemput rakan",
    intro: "Kongsi kod anda. Sesiapa yang mendaftar melaluinya akan direkodkan sebagai rujukan anda.",
    yourCode: "Kod anda",
    codeCopied: "Kod disalin",
    copyCode: "Salin kod",
    yourLink: "Pautan anda",
    joinedThroughYou: "Mendaftar melalui anda",
    namesNotShown: "Dikira daripada pendaftaran yang menggunakan kod anda. Kami tidak memaparkan akaun mereka kepada anda.",
    noRewardTitle: "Tiada ganjaran rujukan sedang dibayar.",
    noRewardBody: "Pendaftaran melalui kod anda telah direkodkan mulai sekarang, jadi tiada yang hilang — tetapi rebat yang anda peroleh hari ini hanyalah daripada permainan anda sendiri. Kami akan memaklumkan di sini apabila perkara itu berubah.",
  },

  winLoss: {
    title: "Menang / kalah",
    intro: "Pusingan yang telah diselesaikan sahaja. Taruhan yang masih berjalan tidak dikira sebelah mana pun.",
    from: "Dari",
    to: "Hingga",
    ranges: { today: "Hari ini", week: "7 hari lalu", month: "30 hari lalu" },
    youAreUp: "Anda untung",
    youAreDown: "Anda rugi",
    staked: "Dipertaruhkan",
    returned: "Dipulangkan",
    rounds: "Pusingan",
    byGameType: "Mengikut jenis permainan",
    dayByDay: "Hari demi hari",
    empty: "Tiada pusingan diselesaikan dalam tempoh ini.",
    roundsStaked: "{rounds} pusingan · {staked} dipertaruhkan",
  },

  wallet: {
    title: "Dompet",
    systemBalance: "Baki utama",
    makeADeposit: "Buat deposit untuk bermula.",
    setAside: "{amount} ditahan",
    addMoney: "Tambah wang",
    withdraw: "Keluarkan",
    recentActivity: "Aktiviti terkini",
    empty: "Tiada apa-apa di sini lagi.",
  },

  money: {
    title: "Kewangan",
    available: "Baki tersedia",
    held: "Ditahan",
    heldHint: "untuk permohonan yang sedang disemak",
    bonus: "Bonus",
    bonusHint: "lengkapkan rollover sebelum boleh dikeluarkan",

    tabs: {
      deposit: "Tambah wang",
      transfer: "Pindahan",
      withdraw: "Pengeluaran",
      history: "Rekod",
      bank: "Bank",
    },

    hints: {
      transfer: "Tukar bonus kepada tunai, atau hantar kepada pemain lain",
      history: "Setiap deposit, pengeluaran dan pergerakan baki",
      bank: "Akaun tempat pengeluaran anda dibayar",
    },
  },

  deposit: {
    noMethodsTitle: "Belum ada kaedah pembayaran",
    noMethodsBody: "Laman ini belum membuka kaedah untuk membuat deposit. Sila hubungi sokongan untuk menambah kredit ke akaun anda.",

    ticketNumber: "Deposit #{id}",
    network: "Rangkaian",
    sendToAddress: "Hantar ke alamat ini",
    copyAddress: "Salin alamat",
    wrongNetwork: "Hantar melalui {network} sahaja. Dana yang dihantar melalui rangkaian lain tidak dapat dipulihkan.",

    cardPendingTitle: "Pembayaran kad masih dalam proses sambungan.",
    cardPendingBody: "Pasukan kami akan menghubungi anda untuk melengkapkan deposit ini, atau anda boleh membatalkannya dan membayar dengan cara lain.",

    transferTo: "Pindahkan {amount} kepada:",
    bank: "Bank",
    accountName: "Nama akaun",
    accountNumber: "No. akaun",
    swift: "SWIFT",
    branch: "Cawangan",
    copyAccount: "Salin nombor akaun",
    quoteReference: "Catatkan {reference} dalam rujukan pindahan supaya ia boleh dipadankan dengan akaun anda.",
    transferToConfirmed: "Pindahkan {amount} ke akaun yang disahkan oleh pasukan kami dengan anda.",
    quoteReferenceGeneric: "Catatkan rujukan {reference} semasa pindahan supaya ia boleh dipadankan dengan akaun anda.",

    expires: "Permohonan ini tamat pada {when}.",
    yourReference: "Rujukan pembayaran anda (pilihan)",
    yourReferencePlaceholder: "Hash transaksi atau rujukan bank",
    yourReferenceHint: "Mempercepatkan pengesahan — pasukan kami memadankannya dengan pembayaran.",
    iHavePaid: "Saya sudah bayar",
    sending: "Menghantar…",

    checkingTitle: "Terima kasih — pasukan kami sedang menyemak pembayaran anda.",
    checkingBody: "Baki anda dikemas kini sebaik sahaja ia disahkan. Belum ada apa-apa yang dikreditkan.",
    makeAnother: "Buat deposit lagi",

    payIn: "Bayar dalam",
    chooseHow: "Pilih cara pembayaran",
    recommended: "Disyorkan",
    selected: "Dipilih",
    min: "Min {amount}",
    max: "Maks {amount}",
    addressLabel: "Alamat {network}",

    amount: "Jumlah",
    otherAmount: "Jumlah lain dalam {currency}",
    aboveMaximum: "Jumlah maksimum sekali bayar bagi kaedah ini ialah {amount}.",
    belowMinimum: "Jumlah minimum bagi kaedah ini ialah {amount}.",
    youWillGet: "Anda akan menerima kira-kira",
    rateIndicative: "Anggaran sahaja. Kadar yang digunakan ialah kadar semasa pembayaran anda disahkan.",
    rateStale: "Kadar ini telah lama tidak dikemas kini dan mungkin telah berubah.",
    rateUnavailable: "Kami tidak dapat mendapatkan kadar {pay} buat masa ini. Deposit anda akan ditukar kepada {account} mengikut kadar semasa ia disahkan.",
    preparing: "Menyediakan…",
    submit: "Deposit {amount}",

    groups: { instant: "Serta-merta", bank: "Bank & kripto" },
  },

  withdraw: {
    doneTitle: "Permohonan diterima. Jumlah itu kini ditahan dan keluar daripada baki yang boleh anda mainkan.",

    blockers: {
      statusTitle: "Akaun anda sedang ditahan",
      statusBody: "Pengeluaran dihentikan sementara. Hubungi sembang langsung dan kami akan menguruskannya.",
      kycTitle: "Beritahu kami ke mana hendak membayar",
      kycBody: "Simpan akaun bank anda dahulu — ia mengambil masa seminit, dan tiada dokumen diperlukan.",
      kycAction: "Tambah akaun bank",
      emailTitle: "Sahkan e-mel anda dahulu",
      emailBody: "Masukkan kod 6 digit yang kami hantar kepada anda.",
      balanceTitle: "Belum ada apa-apa untuk dikeluarkan",
      balanceBody: "Wang yang telah ditahan untuk permohonan lain tidak boleh dikeluarkan dua kali.",
      balanceAction: "Tambah wang",
      dailyTitle: "Itu sahaja untuk hari ini",
      dailyBody: "Anda telah menggunakan kesemua {count} permohonan pengeluaran hari ini. Anda boleh memohon semula esok.",
      turnoverTitle: "Hampir sampai",
      turnoverBody: "Bertaruh {amount} lagi dan pengeluaran akan dibuka.",
      turnoverAction: "Main sekarang",
    },

    sendAs: "Hantar sebagai",
    noMethods: "Belum ada kaedah pengeluaran yang dibuka. Hubungi sembang langsung dan kami akan membantu.",
    today: "Pengeluaran hari ini",
    amount: "Jumlah",
    walletAddress: "Alamat dompet",
    walletAddressPlaceholder: "Alamat {network} anda",
    walletAddressWarning: "Mesti alamat {network}. Kami tidak dapat memulihkan dana yang dihantar ke rangkaian yang salah.",

    whichAccount: "Akaun yang mana?",
    paidIntoSaved: "Dibayar ke akaun bank yang anda simpan",
    noAccountSaved: "Belum ada akaun bank disimpan.",
    onlySavedAccounts: "Pengeluaran hanya masuk ke akaun yang anda telah simpan dan kami telah semak.",
    addAnother: "Tambah satu lagi",
    ownName: "— ia mesti atas nama anda sendiri.",

    holdTitle: "Wang ditahan sebaik sahaja anda memohon.",
    holdBody: "Ia terus keluar daripada baki yang boleh anda mainkan, dan hanya kembali jika anda membatalkannya atau kami tidak dapat meluluskannya. Batalkan bila-bila masa daripada Rekod semasa ia masih menunggu.",
    holdTurnover: "Anda juga perlu bertaruh sekurang-kurangnya sebanyak yang anda masukkan sebelum kami boleh menghantar pengeluaran.",

    playRequirement: "Syarat rollover",
    requesting: "Menghantar…",
    submit: "Mohon pengeluaran",
  },

  transfer: {
    cash: "Tunai",
    setAside: "{amount} ditahan",
    bonus: "Bonus",

    modes: { bonus: "Bonus → Tunai", member: "Hantar kepada pemain" },

    bonusIntro: "Kredit bonus belum boleh dikeluarkan sehingga anda melengkapkan rollover. Memindahkannya ke sini ialah saat ia menjadi wang sebenar.",
    playedThrough: "Rollover selesai",
    amountToMove: "Jumlah untuk dipindahkan",
    moving: "Memindahkan…",
    moveToCash: "Pindah ke tunai",
    keepPlaying: "Teruskan bermain untuk membukanya.",

    amount: "Jumlah",
    sendTo: "Hantar kepada",
    theirUsername: "Nama pengguna mereka",
    note: "Nota",
    checkUsernameTitle: "Semak nama pengguna dengan teliti.",
    checkUsernameBody: "Pindahan terus masuk ke baki pemain itu dan tidak boleh dipulangkan.",
    transfersLeft: "Anda ada {left} daripada {total} pindahan lagi hari ini.",
    send: "Hantar",
  },

  history: {
    show: "Papar",
    everything: "Semua",
    moneyIn: "Wang masuk",
    moneyOut: "Wang keluar",
    from: "Dari",
    to: "Hingga",

    ranges: {
      today: "Hari ini",
      yesterday: "Semalam",
      week: "7 hari lalu",
      month: "30 hari lalu",
    },

    empty: "Tiada apa-apa dalam tempoh ini. Cuba julat tarikh yang lebih luas.",
    cancelHold: "Batalkan dan lepaskan tahanan",
    cancelling: "Membatalkan…",
    requested: "{amount} dimohon",
    shortBy: "kurang",
    overBy: "lebih",

    kind: { deposit: "Deposit", withdrawal: "Pengeluaran" },

    status: {
      AwaitingConfirmation: "Menunggu pengesahan",
      Pending: "Menunggu",
      Completed: "Selesai",
      Rejected: "Ditolak",
      Cancelled: "Dibatalkan",
      Expired: "Tamat tempoh",
      Approved: "Diluluskan",
      Processing: "Sedang diproses",
    },
  },
};
